"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLoginMessage = mapLoginMessage;
/**
 * User session data returned from LOGIN (ma) command.
 */
/** Human-readable `ml` (password login) status messages — Android E0.j / E0.java */
function mapLoginMessage(status) {
    if (status === 0)
        return 'Вход выполнен';
    if (status === 3)
        return 'Неверный логин или пароль';
    if (status === 4)
        return 'Требуется ввод капчи';
    return `Не удалось войти (код ${status})`;
}
